import { Component, Input, OnInit } from "@angular/core";
import { PlayerDto } from "app/models";

@Component({
    selector: 'tactic-player-skills',
    templateUrl: './tactic-player-skills.component.html',
    styleUrls: ['./tactic-player-skills.component.scss'],
})
export class TacticPlayerSkills implements OnInit {
    private usePlayerForm: boolean = false;
    
    @Input()
    player: PlayerDto;
    
    @Input()
    set displayRealSkills(val: boolean) {
        this.usePlayerForm = val;
    }

    get displayRealSkills(): boolean {
        return this.usePlayerForm;
    }

    ngOnInit(): void {
        
    }
}